import { render, staticRenderFns } from "./RedirectModal.vue?vue&type=template&id=5126eeb0&scoped=true"
import script from "./RedirectModal.vue?vue&type=script&lang=js"
export * from "./RedirectModal.vue?vue&type=script&lang=js"
import style0 from "./RedirectModal.vue?vue&type=style&index=0&id=5126eeb0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5126eeb0",
  null
  
)

export default component.exports